import React, { Component } from "react";
import Loading from './loading';
import DeviceIdentifier from 'react-device-identifier';
import styled from 'styled-components';
import Navbar from 'react-bootstrap/Navbar'
import Nav from 'react-bootstrap/Nav'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Card from 'react-bootstrap/Card'
import Button from 'react-bootstrap/Button'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLongArrowAltRight } from '@fortawesome/free-solid-svg-icons'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Fade } from 'react-reveal';

const ContentStyles = styled.div`
.slick-list {margin: 0 -15px;}
.slick-slide>div {padding: 0 15px;}
.slick-dots li button:before {
  font-size: 20px;
  line-height: 30px;
  width: 30px;
  height: 30px;
  opacity: 0.25;
  color: #095099;
}
.slick-dots li.slick-active button:before {
  opacity: 1;
  color: #095099;
  border: 1px solid #095099;
  border-radius: 50%;
}
.konutProjectsHome .card {
  border: none;
}
`;


class Projects extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      isLoaded: false,
      items: []
    };
  }

  componentDidMount() {
    fetch("/json/konutlar.json?v=" + process.env.REACT_APP_SITE_VERSION)
      .then(res => res.json())
      .then(
        (result) => {
          this.setState({
            isLoaded: true,
            headers: {
              "Content-Type": "application/json"
            },
            items: result
          });
        },
        // Not: Burada hataları yakalamak önemlidir.
        // Bileşenimizde bug bulunmaması için, 'catch ()' bloğu yerine bulunan
        // bu blok içinde hatalar yakalanır.
        (error) => {
          this.setState({
            isLoaded: true,
            error
          });
        }
      )
  }

  render() {
    const { error, isLoaded, items } = this.state;
    if (error) {
      return <div>Error: {error.message}</div>;
    } else if (!isLoaded) {
      return <Loading />;
    } else {
      const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        lazyLoad: false,
        centerMode: false,
        slidesToShow: 5,
        slidesToScroll: 1,
        arrows: false,
        responsive: [
          {
            breakpoint: 1690,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
              dots: true
            }
          },
          {
            breakpoint: 1400,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              dots: true
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              dots: true
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: true
            }
          }
        ]
      };
      return (
        <>
          <ContentStyles>
            <Container fluid>
              <Row>
                <Col>
                  <Navbar className="konutProjectHeader mt-5 pt-5">
                    <Container>
                      <Fade>
                        <h2>Anlaşmalı Konut Projeleri</h2>
                        <Navbar.Collapse id="responsive-navbar-nav">
                          <Nav className="ml-auto">
                            <Nav.Link href="/anlasmali-konut-projeleri">Tüm Projeler <FontAwesomeIcon size="lg" className="ml-3" icon={faLongArrowAltRight} /></Nav.Link>
                          </Nav>
                        </Navbar.Collapse>
                      </Fade>
                    </Container>
                  </Navbar>
                </Col>
              </Row>
              <Row className="konutProjectsHome mb-5 pb-5">
                <Col>
                  <Slider {...settings}>
                    {
                      items.filter(items => items.homevisible === true).map((projects, i) => {
                        return (
                          <Fade key={i} bottom cascade>
                            <Card data-index={i} className="text-white">
                              <DeviceIdentifier isDesktop={true}>
                                <a href={'anlasmali-konut-projeleri/' + projects.guid}>
                                  <Card.Img src={`/projects/${projects.guid}/${projects.featuredimage}`} alt={projects.name} />
                                </a>
                                <Card.ImgOverlay>
                                  <Card.Title className="mt-3">{projects.name}</Card.Title>
                                  <Card.Text>{projects.summary}</Card.Text>
                                  <Button href={'anlasmali-konut-projeleri/' + projects.guid} variant="outline-secondary">İNCELE</Button>
                                </Card.ImgOverlay>
                              </DeviceIdentifier>
                              <DeviceIdentifier isMobile={true} isTablet={true}>
                                <a className="imageContainer" href={'anlasmali-konut-projeleri/' + projects.guid}>
                                  <Card.Img src={`/projects/${projects.guid}/${projects.featuredimage}`} alt={projects.name} />
                                </a>
                                <Card.Body>
                                  <Card.Title className="mt-3">{projects.name}</Card.Title>
                                  <Card.Text>{projects.summary}</Card.Text>
                                  <Button href={'anlasmali-konut-projeleri/' + projects.guid} variant="outline-primary">İNCELE</Button>
                                </Card.Body>
                              </DeviceIdentifier>
                            </Card>
                          </Fade>
                        );
                      })
                    }
                  </Slider>
                </Col>
              </Row>
            </Container>
          </ContentStyles>
        </>
      );
    }
  }
}

export default Projects;